import React, { FC, Suspense, lazy } from 'react';

import { LivePersonaCardGroupProps } from './LivePersonaCardGroup';

const LivePersonaCardGroup = lazy(
  () => import(/* webpackChunkName: "4-feat-live-persona-card-group" */ './LivePersonaCardGroupErrorBoundary')
);

const LoadableLivePersonaCardGroup: FC<LivePersonaCardGroupProps> = (props) => (
  <Suspense fallback={<>{props.children}</>}>
    <LivePersonaCardGroup {...props} />
  </Suspense>
);

export default LoadableLivePersonaCardGroup;
